import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginPageComponent} from './achelos-iot/login-page/login-page.component';
import {MainPageComponent} from './achelos-iot/main-page/main-page.component';
import {AuthGuardService as AuthGuard} from './shared/services/auth/auth-guard.service';
import {SubscriptionPoolsPageComponent} from './achelos-iot/subscription-pools-page/subscription-pools-page.component';
import {CardGroupsComponent} from "./achelos-iot/card-groups/card-groups.component";
import {UserManagementComponent} from "./achelos-iot/user-management/user-management.component";


const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginPageComponent },
  { path: 'login/:userType', component: LoginPageComponent },
  { path: 'main', component: MainPageComponent, canActivate: [ AuthGuard ] },
  { path: 'subscription-pools', component: SubscriptionPoolsPageComponent, canActivate: [ AuthGuard ] },
  { path: 'card-groups', component: CardGroupsComponent, canActivate: [ AuthGuard ] },
  { path: 'user-management', component: UserManagementComponent, canActivate: [ AuthGuard ] }
];

@NgModule( {
  imports: [ RouterModule.forRoot( routes ) ],
  exports: [ RouterModule ]
} )
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts